<template>
    <v-dialog v-model="mostrar" persistent max-width="70vw" scrollable>
		<v-card max-height="600px">
			<v-toolbar flat color="primary white--text"><h1>Curso</h1></v-toolbar>
			<v-divider></v-divider>
            <v-card-text>
            <v-container>
                <v-row>
                    <v-col cols="12" class="col-sm-2">
                        <v-text-field dense label="Código" readonly v-model="curso.id" outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" class="col-sm-2">
                        <v-select dense :items="this.graus" v-model="curso.grau" label="Grau" outlined></v-select>
                    </v-col>
                    <v-col cols="12" class="col-sm-4">
                        <v-text-field v-if="this.curso.id > 0" dense label="Arquivo imagem" v-model="arquivoImg.name" readonly outlined></v-text-field>
                    </v-col>
                    <v-col>
                        <input v-if="this.curso.id > 0" type="file" ref="imgFile" @change="onFileImgSelected" style="display:none" />
                        <v-btn v-if="this.curso.id > 0" small color="primary my-4" @click="launchFilePickerImg()">Selecionar arquivo</v-btn>
                    </v-col>
                    <v-col>
                        <v-btn small v-if="salvarImg" color="primary my-4" @click="uploadImg">Enviar Arquivo</v-btn>
                    </v-col>
                    <v-col cols="12" class="col-sm-6">
                        <v-text-field dense label="Título" v-model="curso.nome" outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" class="col-sm-6">
                        <v-select dense item-text="text" item-value="value" :items="this.mestres" v-model="curso.instrutor" label="Instrutor" outlined></v-select>
                    </v-col>
                    
                    <v-col cols="12" class="col-sm-12">
                        <v-textarea auto-grow dense label="Descrição" v-model="curso.descricao" outlined></v-textarea>
                    </v-col>
                    <v-col cols="12" class="col-sm-12">
                        <!--TODO trocar por vue editor -->
                        <v-textarea auto-grow dense label="Texto conclusão" v-model="curso.texto_conclusao" outlined></v-textarea>
                    </v-col>
                </v-row>
                <v-row v-if="curso.id > 0">
                    <v-col>
                        <Modulos :idCurso="curso.id" :modulos="curso.modulos" @abrirNovoModulo="abrirModulo($event)" @atualizaModulos="atualizaModulos($event)" @excluirModulo="retirarModuloExcluido($event)" />
                    </v-col>
                </v-row>
            </v-container>
            </v-card-text>
            <v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="primary" @click.stop="salvar()">Salvar</v-btn>
				<v-btn text color="primary" @click.stop="fechar()">Fechar</v-btn>
			</v-card-actions>
		</v-card>
    </v-dialog>    
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showSuccess, showError } from "@/config/global"
import Modulos from '@/components/admin/cursos/Modulos'


export default {
    name:'Curso',
    props:['mostrar', 'cursoEdicao'],
    components:{Modulos},
    computed:{
        graus(){
				let arr = []
				for( let i = 1; i <= 7; i++){
					arr[i-1] = {value: i.toString(), text: i.toString()}
				}
				
				return arr;
			},
    },
    data(){
        return{
            curso: {
                id: 0
            },
            mestres: [],
            salvarImg: false,
            arquivoImg: {},
        }
    },
    methods:{
        launchFilePickerImg(){
            this.$refs.imgFile.click()
        },
        onFileImgSelected(ev){
            
            this.arquivoImg = ev.target.files[0]
            
            if(!this.arquivoImg.type.match('image.*')){
                showError("Arquivo selecionado nao corresponde a uma imagem")
                this.salvarImg = false
            }else{
                this.salvarImg = true
            }
        },
        uploadImg(){
            let idCurso = this.curso.id
            let nomeArquivo = this.arquivoImg.name

            const url = `${baseApiUrl}/Cursos/uploadImg.php`
            let reader = new FileReader()
            reader.onloadend = function(){
                let img64 = reader.result
                let obj = {
                    arquivo: img64,
                    curso: idCurso,
                    nomeArquivo: nomeArquivo
                }

                axios.post(url, obj).then(res => {
                    if(res.data.codigo == '01'){
                        showSuccess(res.data.mensagem)
                    }else{
                        showError(res.data.mensagem)
                    }
                })
            }
            reader.readAsDataURL(this.arquivoImg)
        },

        atualizaModulos(modulo){
            let atualizou = false
            if(this.curso.modulos != undefined){
                this.curso.modulos.forEach((v, i) => {
                    if (v.id == modulo.id){
                        this.curso.modulos[i] = modulo
                        atualizou = true
                    }
                })
            }else{
                this.curso.modulos[0] = modulo
                atualizou = true
            }
            
            if(!atualizou){
                this.curso.modulos.push(modulo)
            }
        },

        atualizaNomeInstrutor(){
            this.mestres.forEach(v => {
                if(this.curso.instrutor == v.value){
                    this.curso.nome_instrutor = v.text
                }
            })
        },

        async buscaInstrutores(){
            const url = `${baseApiUrl}/Cursos/readInstrutores.php`

            await axios.get(url).then(res => {

                if(res.data.codigo == '01'){
                    this.mestres = res.data.dados.map(c => {

                        return{
                            ...c,
                        }
                    })
                }
            })
        },
        salvar(){
            if(this.curso.id == 0){
                const url = `${baseApiUrl}/Cursos/insert.php`
                
                axios.post(url, this.curso)
                .then(res => { 
                    if(res.data.codigo == '01'){
                        showSuccess(res.data.mensagem)
                        this.curso = res.data.curso
                        this.$emit('cursoCadastrado', this.curso)
                    }else{
                        showError(res.data.mensagem)
                    }
                })
            }else{
                const url = `${baseApiUrl}/Cursos/update.php`

                axios.post(url, this.curso)
                .then(res => { 
                    if(res.data.codigo == '01'){
                        showSuccess(res.data.mensagem)
                        this.atualizaNomeInstrutor()
                        this.$emit('cursoAtualizado', this.curso)
                        this.fechar()
                    }else{
                        showError(res.data.mensagem)
                    }
                })
            }
        },

        fechar(){
            this.curso = {id: 0},
            this.$emit('fecharCurso')
        },

        retirarModuloExcluido(id){
            let idx = this.curso.modulos.findIndex(v => {
                return v.id == id
            })

            this.curso.modulos.splice(idx, 1)
        }

    },
    watch:{
        mostrar(v){
            if(v){
                this.buscaInstrutores()
                if(this.cursoEdicao.id){
                    this.curso = this.cursoEdicao
                }
                
            }
        }
    },
}
</script>

<style scoped>

</style>